import React, { useState, useContext, useEffect } from "react";

import srPic from "../images/pictures/Success Register.png";

import { auth } from "../Utils/firebase";
import { AuthContext } from "../context/AuthContext";

function SuccessRegister() {
  const { userAuth, logout } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [hasSent, setHasSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendVerify = () => {
    setLoading(true);

    userAuth
      .sendEmailVerification()
      .then(function () {
        // Email sent.
        setError(null);
        setLoading(false);
        setHasSent(true);
      })
      .catch(function (error) {
        // An error happened.
        setError("Something went wrong!");
        setLoading(false);
      });
  };

  const signOut = () => {
    auth
      .signOut()
      .then(() => {
        // Sign-out successful.
        logout();
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  };

  useEffect(() => {
    document.title = "Success Register!";
    return () => {
      document.title = "Flipcard";
    };
  }, []);

  return (
    <>
      {userAuth && (
        <div className="box">
          <h2 className="darktextColor textBrand">flipcard.xyz</h2>
          <p className="darktextMuteColor text">
            Check your email to get link verification!
          </p>
          <div className="picture">
            <img src={srPic} alt="Success Register" title="Succes Register" />
          </div>
          <form className="success-form">
            <div className="grup-input">
              <label className="wrapper">
                <div className="darktextColor text">
                  {error ? error : "You don't receive the email ?"}
                </div>
              </label>
            </div>
            <button
              className="btn-in darktextColor textTitle "
              onClick={sendVerify}
              disabled={loading}
            >
              {loading ? "Sending ... " : "Send Email"}
            </button>
            {hasSent ? (
              <div className="grup-input">
                <label className="wrapper">
                  <div className="darktextColor textSmall">
                    Email verification has been sent!
                  </div>
                </label>
              </div>
            ) : null}
          </form>
          <div className="link-wrapper">
            <span className="text" onClick={signOut}>
              Sign out
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default SuccessRegister;
